export default "__VITE_ASSET__BVI1KyoN__"